import type { Order } from '../api/trading';
import { num, tenths, toTenths } from '../format';

export type OrderOutcome = { text: string; tone: 'down' | 'info' };

/** What actually happened to an order, in words (plan 072). "Order sent" is only for one that filled or is resting. */
export function orderOutcome(placed: Order, headline: string, anyBid: boolean, held: number | null): OrderOutcome {
  if (placed.status === 'rejected') return { text: `Rejected · ${headline}${placed.reason ? ` · ${placed.reason}` : ''}`, tone: 'down' };
  if (placed.status !== 'cancelled') return { text: `Order sent · ${headline}`, tone: 'info' };
  const wanted = Number(placed.quantity), filled = Number(placed.filled_quantity);
  const price = tenths(toTenths(placed.limit_price));
  const allOrNothing = placed.time_in_force === 'fill_or_kill';
  if (placed.action === 'buy') {
    if (filled > 0) return { text: `Bought ${num(filled)} of ${num(wanted)} · the rest wasn’t offered at ${price} or better`, tone: 'info' };
    return { text: `Not filled · ${allOrNothing ? `not enough offered at ${price} for all ${num(wanted)}` : `nothing offered at ${price} or better`} · nothing bought`, tone: 'down' };
  }
  const left = held == null ? 0 : held - filled;
  const holding = left > 0 ? ` · you still hold ${num(left)}` : '';
  const bids = anyBid ? 'bids' : `bids at ${price} or better`;
  if (filled > 0) return { text: `Sold ${num(filled)} of ${num(wanted)} · no more ${bids}${holding}`, tone: 'down' };
  return { text: `Not sold · ${allOrNothing ? `not enough ${bids} for all ${num(wanted)}` : `no ${bids}`}${holding}`, tone: 'down' };
}
